let anchorNum = 1
document.querySelectorAll('a').forEach(link => {
  anchorNum++
  if (
    link.getAttribute('href') == '' ||
    link.getAttribute('href') == 'javascript:void(0)'
  ) {
    link.setAttribute('href', '#')
  }
})

const slideObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('slide_active')
    }
  })
})

const svgObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('svg_scroll_active')
    }
  })
})

const sectionObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('section-show')
    }
  })
})

const hiddenSection = document.querySelectorAll('section')

if (
  document.querySelector('#animate_js').classList.contains('section-animate')
) {
  hiddenSection.forEach(el => {
    sectionObserver.observe(el)
  })
} else {
  hiddenSection.forEach(el => {
    el.classList.add('section-show')
  })
}

hiddenSection.forEach(el => {
  sectionObserver.observe(el)
})

function svgAnimate () {
  let svgEl = document.querySelectorAll('.svg_scroll_observer')

  svgEl.forEach(el => {
    svgObserver.observe(el)
  })
}

svgAnimate()

function accordionMain () {
  let accordionSec = document.querySelectorAll('.accordion-section')

  for (let i = 0; i < accordionSec.length; i++) {
    let accordion = accordionSec[i].querySelectorAll('.faq-div')

    accordion.forEach(item => {
      document.addEventListener('keyup', e => {
        if (e.target === item && e.key == 'Enter') {
          accordionHide()
          item.classList.toggle('accordion-active')
          console.log('Faq Enter Working!!')
        }
      })
      item.addEventListener('click', e => {
        accordionHide()
        item.classList.toggle('accordion-active')
      })
    })
  }
}

function accordionHide () {
  let accordionSec = document.querySelectorAll('.accordion-section')

  for (let i = 0; i < accordionSec.length; i++) {
    let accordion = accordionSec[i].querySelectorAll('.faq-div')

    accordion.forEach(item => {
      item.classList.remove('accordion-active')
    })
  }
}

accordionMain()

// Page Loader

window.addEventListener('load', e => {
  let pageLoader = document.querySelector('#page_loader')
  if (pageLoader) {
    pageLoader.classList.add('hide')
  }
})

// Aria Accessibility

let allButtons = document.querySelectorAll('button')

if (allButtons) {
  allButtons.forEach(button => {
    if (
      !button.hasAttribute('aria-label') ||
      button.getAttribute('aria-label') == ''
    ) {
      if (button.querySelector('.aria-label')) {
        button.setAttribute(
          'aria-label',
          button.querySelector('.aria-label').innerText
        )
      } else if (button.innerText) {
        button.setAttribute('aria-label', button.innerText)
      } else {
        button.setAttribute('aria-label', 'button')
      }
    }
  })
}

let allLinks = document.querySelectorAll('a')

if (allLinks) {
  allLinks.forEach(link => {
    if (
      !link.hasAttribute('aria-label') ||
      link.getAttribute('aria-label') == ''
    ) {
      if (link.querySelector('.aria-label')) {
        link.setAttribute(
          'aria-label',
          link.querySelector('.aria-label').innerText
        )
      } else if (link.innerText) {
        link.setAttribute('aria-label', link.innerText)
      } else {
        link.setAttribute('aria-label', 'link')
      }
    }
  })
}

let ariaControls = document.querySelectorAll('[aria-controls]')

if (ariaControls) {
  ariaControls.forEach(el => {
    let modalEl = document.querySelector(`#${el.getAttribute('aria-controls')}`)
    el.setAttribute('aria-expanded', 'false')
    el.addEventListener('click', e => {
      if (el.getAttribute('aria-expanded') == 'true') {
        el.setAttribute('aria-expanded', 'false')
      } else {
        el.setAttribute('aria-expanded', 'true')
      }
    })
    el.addEventListener('keyup', e => {
      if (e.key == 'Enter') {
        if (el.getAttribute('aria-expanded') == 'true') {
          el.setAttribute('aria-expanded', 'false')
        } else {
          el.setAttribute('aria-expanded', 'true')
        }
        if (modalEl) {
          modalEl.setAttribute('tabindex', 0)
          console.log(modalEl)
          modalEl.focus()
        }
      }
    })
    document.addEventListener('keyup', e => {
      if (e.key == 'Escape') {
        el.setAttribute('aria-expanded', 'false')
      }
    })
  })
}

//  Video Poster

let videoPoster = document.querySelectorAll('video[poster]')

if (videoPoster) {
  videoPoster.forEach(videoEl => {
    videoEl.querySelector('img').setAttribute('loading', 'lazy')
    videoEl.querySelector('img').setAttribute('alt', 'video_thumbnail')
  })
}

//  Zoom on Image Hover

$('.zoom-image')
  // tile mouse actions
  .on('mouseover', function () {
    $(this)
      .children('img')
      .css({ transform: 'scale(' + $(this).attr('data-scale') + ')' })
  })
  .on('mouseout', function () {
    $(this).children('img').css({ transform: 'scale(1)' })
  })
  .on('mousemove', function (e) {
    $(this)
      .children('img')
      .css({
        'transform-origin':
          ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
          '% ' +
          ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
          '%'
      })
  })

// AR Button

function setupShopifyXr () {
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function () {
      setupShopifyXr()
    })
  } else {
    document.querySelectorAll('[id^="ProductJSON-"]').forEach(modelJSON => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent))
      modelJSON.remove()
    })
    window.ShopifyXR.setupXRElements()
  }
}

window.Shopify.loadFeatures([
  {
    name: 'shopify-xr',
    version: '1.0',
    onLoad: setupShopifyXr
  }
])

// Back to Top

let backToTop = document.querySelector('.back-to-top')

if (backToTop) {
  backToTop.addEventListener('click', e => {
    window.scrollTo(0, 0)
  })
}

// Size Chart

let sizeChartBtns = document.querySelectorAll('.size_chart_btn')

if (sizeChartBtns) {
  sizeChartBtns.forEach(sizeChartBtn => {
    let wrapper = sizeChartBtn.closest('.option__field')
    let sizeChart = wrapper.querySelector('.size-chart')
    let sizeChartClose = wrapper.querySelector('.size_chart_close')
    
    sizeChartBtn.addEventListener('click', () => {
      sizeChart.classList.add('modal-active')
    })

    sizeChartClose.addEventListener('click', () => {
      sizeChart.classList.remove('modal-active')
    })
  })
}

// Animation observer

document.addEventListener('DOMContentLoaded', e => {
  let animationObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animation_active')
      }
    })
  })

  let animationEls = document.querySelectorAll('[data-animation-main]')
  if (animationEls) {
    animationEls.forEach(el => {
      let delay = el.getAttribute('data-animation-delay')
      if (delay) {
        el.style.transitionDelay = `${delay}s`
      }
      animationObserver.observe(el)
    })
  }
})

let productItems = document.querySelectorAll('.product_item_main')

if (productItems) {
  productItems.forEach(item => {
    item.addEventListener('keyup', e => {
      if (e.key == 'Tab') {
        item.querySelector('.product-button').style.transform = 'translateY(0)'
        item.querySelector('.product-button').style.opacity = '1'
        item.querySelector('.product-button').style.visibility = 'visible'
        item.querySelector('.icon-wrap').style.opacity = '1'
        item.querySelector('.icon-wrap').style.visibility = 'visible'
      }
    })
    let productBtn = item.querySelector('.product-button')

    productBtn.addEventListener('keyup', e => {
      if (e.key == 'Enter' || e.key == ' ') {
        let productAdd = productBtn.querySelector('.product-add a')
        if (productAdd) {
          productAdd.click()
        } else {
          productBtn.querySelector('a').click()
        }
      }
    })
  })
}

function circleText () {
  let text = document.querySelectorAll('.circle-text-wrap')

  for (let i = 0; i < text.length; i++) {
    text[i].innerHTML = text[i].textContent.replace(/\S/g, '<span>$&</span>')
    const el = text[i].querySelectorAll('span')
    for (let j = 0; j < el.length; j++) {
      el[j].style.transform = 'rotate(' + j * 16.5 + 'deg)'
      if (j > 21) {
        el[j].remove()
      }
    }
  }
}

circleText()

let productTexts = document.querySelectorAll('.product-description')

if (productTexts) {
  productTexts.forEach(el => {
    let text = el.textContent.trim()
    let words = el.getAttribute('data-words')
    if (words) {
      words = Number(words)
      let truncate = `${text.split(' ').splice(0, words).join(' ')}...`
      let readBtn = document.createElement('button')
      readBtn.classList.add('text-btn')
      readBtn.classList.add('read__more')
      readBtn.innerHTML = `<a href="#" class="animate-btn">read more</a>`
      el.innerHTML = truncate
      el.append(readBtn)
      readBtn.addEventListener('click', e => {
        el.textContent = text
      })
    }
  })
}
